import {supabase} from "../components/supabaseClient"
import {useNavigate,useLoaderData, useLocation} from "react-router-dom"

export default function Header () {
  const location = useLocation();

  const navigate = useNavigate();
  const session:any = useLoaderData()

  console.log(location.pathname)
  
  const handleSignOut = async () => {
    const { error } = await supabase.auth.signOut()
    
    navigate("/sign_in")
  }


  return (
    <div className="bg-white lg:pb-12">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
        <header className="flex items-center justify-between py-4 md:py-8">
          <a href="/" className="inline-flex items-center gap-2.5 text-2xl font-bold text-black md:text-3xl" aria-label="logo">
            Time Capsule comment
          </a>

          {/*<!-- nav - start -->*/}
          <nav className="hidden gap-12 lg:flex">
            {
              location.pathname === "/" ? 
                <a href="/" className="text-lg font-semibold text-indigo-600 transition duration-100 hover:text-indigo-500 active:text-indigo-700">記事一覧</a>
                :
                <a href="/" className="text-lg font-semibold text-gray-600 transition duration-100 hover:text-indigo-500 active:text-indigo-700">記事一覧</a>
            }
            <a href="#" className="text-lg font-semibold text-gray-600 transition duration-100 hover:text-indigo-500 active:text-indigo-700">コメント一覧</a>
            <a href="#" className="text-lg font-semibold text-gray-600 transition duration-100 hover:text-indigo-500 active:text-indigo-700">その他</a>
          </nav>
          {/*<!-- nav - end -->*/}

        {
          session ===null ?
            <div className="-ml-8 hidden flex-col gap-2.5 sm:flex-row sm:justify-center lg:flex lg:justify-start">
              <button className="inline-block rounded-lg bg-indigo-500 px-8 py-3 text-center text-sm font-semibold text-white outline-none ring-indigo-300 transition duration-100 hover:bg-indigo-600 focus-visible:ring active:bg-indigo-700 md:text-base">Sign In</button>
            </div>
          :
            <>
              <div className="text-lg font-semibold text-gray-500">サインイン中:{session.user.email}</div>
              <div className="-ml-8 hidden flex-col gap-2.5 sm:flex-row sm:justify-center lg:flex lg:justify-start">
                <button onClick={handleSignOut} className="inline-block rounded-lg bg-indigo-500 px-8 py-3 text-center text-sm font-semibold text-white outline-none ring-indigo-300 transition duration-100 hover:bg-indigo-600 focus-visible:ring active:bg-indigo-700 md:text-base">Sign Out</button>
              </div>
            </>
        }

          <button type="button" className="inline-flex items-center gap-2 rounded-lg bg-gray-200 px-2.5 py-2 text-sm font-semibold text-gray-500 ring-indigo-300 hover:bg-gray-300 focus-visible:ring active:text-gray-700 md:text-base lg:hidden">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />
            </svg>

            Menu
          </button>
        </header>
      </div>
    </div>
  )

}